import React, { useEffect, useState } from 'react';
import { Spin } from 'antd';
import Calendar from '../Calendar';
import StyledCard from './components/StyledCard.jsx';
import { Beforeunload } from './components';
import LabTimesheet from '../Lab/LabTimesheet.jsx';

const LrsHome = () => { 
  return (
    <StyledCard>     
      <div data-test="grid-display">
        <Calendar />          
        <LabTimesheet />          
      </div>
      <Beforeunload />
    </StyledCard>
  );
}

export default LrsHome;
